import type { StatementsConfig } from '../ProductsConfig';
import { config as deliveryChange } from './delivery-change-config/RS';

export const statements: StatementsConfig = {
    validate: {
        periodLength: false,
        maxDaysInPast: false,
    },
    creation: {
        differenceLimit: 31,
    },
    /** Hardcoded minimum date value */
    specificMinDate: null as string | null,
    /** Show statements list if enabled */
    list: {
        enabled: true,
    },
    addAccessTokenToDownloadParams: false,
    addAccessTokenToDownloadBody: true,
    signed: false,
    /** Enables MoneyAsideSwitchFilter if subAccounts.length > 0 */
    subAccountStatements: false,
    deliveryEditorVersion: 1,
    forceNoEmail: false,
    deliverySelectable: false,
    creditCardDeliverySelectable: false,
    showEmailIDsDropdown: true,
    modes: {
        electronic: 'ELECTRONICALLY',
        postal: 'POSTAL',
    },
    deliveryChange,
    deliveryDefinitions: {
        enabled: false,
        productTypes: [] as string[],
        languages: [] as string[],
        showStatementNumberCell: false,
        showStatementLanguageCell: false,
        showFormatWithTranslation: false,
        showFeesWarning: false,
        showLanguageField: false,
        showFormatField: false,
        showEmailSelect: false,
    },
    tableColumns: {
        DEFAULT: ['NAME', 'TIMESPAN', 'BANKSIGNED'] as string[] | null,
        CREDIT: ['NAME', 'INVOICE_DATE', 'DOWNLOAD'] as string[] | null,
    },
    downloadParamName: 'statementId',
    signedDownloadParamName: 'statementId',
    formDownload: false,
    isDescriptionInputVisible: false,
    isEmailInputVisible: false,
    showDeliveryStatementsInfo: false,
    newStatement: {
        maxDescriptionLength: 34,
        maxEmailLength: 75,
        maxDaysBetweenErrorKey: 'account.statements.newStatement.max90DaysBetween',
    },
};
